import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { Link } from 'gatsby';
import { FiInfo } from 'react-icons/fi';
import { Counter, LikeButton, RegVideo, Video } from '../components/Complete/';
export const _frontmatter = {
  "frontmatter": null
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <section className="mdx-page">
      <h2>{`my first mdx file`}</h2>
      <p><strong parentName="p">{`Woke forage vinyl coloring book direct trade readymade glossier. Fixie fashion axe stumptown, actually activated charcoal you probably haven't heard of them venmo pinterest mlkshk cray salvia jean shorts.`}</strong>{`
Cardigan humblebrag master cleanse, godard salvia meh small batch you probably haven't heard of them. `}<em parentName="p">{`Cliche XOXO affogato, blog fixie pitchfork art party humblebrag.`}</em></p>
      <div className="code">
        <pre><code parentName="pre" {...{
            "className": "language-js"
          }}>{`const firstName = 'Zenis';
const lastName = 'Losiuks';
`}</code></pre>
      </div>
      <div className="nice-text">
        <h3>nice text</h3>
        <FiInfo className="nice-text-icon" mdxType="FiInfo" />
        <p>{`Vaporware godard keffiyeh, subway tile kickstarter ethical waistcoat coloring book sustainable taxidermy raw denim franzen intelligentsia. Locavore brunch shabby chic flexitarian, coloring book tousled retro vexillologist pickled subway tile forage pug. Synth semiotics flexitarian, pork belly lomo offal tacos brunch drinking vinegar ethical prism stumptown. Sartorial vaporware palo santo, twee stumptown hammock lomo. Selfies narwhal occupy master cleanse squid hashtag +1 salvia enamel pin. Flexitarian forage synth four loko everyday carry.`}</p>
      </div>
      <h2>React Components</h2>
      <Counter mdxType="Counter" />
      <pre><code parentName="pre" {...{
          "className": "language-jsx"
        }}>{`import React from 'react';
import styled from 'styled-components';
import { AiOutlineLike } from 'react-icons/ai';
const LikeButton = () => {
  const [value, setValue] = React.useState(0);
  return (
    <Wrapper>
      <div>
        <button onClick={() => setValue(value + 1)}>
          <AiOutlineLike />
        </button>
        <p>
          Liked the post?
          <br />
          Click thumbs up few times
        </p>
      </div>
      <span>+{value}</span>
    </Wrapper>
  );
};
`}</code></pre>
      <LikeButton mdxType="LikeButton" />
      <h2>video components</h2>
      <RegVideo mdxType="RegVideo" />
      <Video mdxType="Video" />
      <h2>regular heading</h2>
      <h2 title="true">title heading</h2>
      <h4>inline code</h4>
      <p><inlineCode parentName="p">{`console.log('hello there')`}</inlineCode></p>
      <h4>blockquote element</h4>
      <blockquote display="default">
  Lorem ipsum dolor sit amet consectetur adipisicing elit. Eos, aspernatur quam.
  Libero eius rerum incidunt!
      </blockquote>
      <blockquote display="info">
  Lorem ipsum dolor sit amet consectetur adipisicing elit. Eos, aspernatur quam.
  Libero eius rerum incidunt! Lorem ipsum dolor sit amet consectetur adipisicing
  elit. Animi similique eveniet laborum magni molestiae optio, voluptates
  dolorum alias? Explicabo, ad ut. Voluptates, quod fugiat repellendus molestias
  quibusdam ullam ratione mollitia.
      </blockquote>
      <blockquote display="warning">
  Lorem ipsum dolor sit amet consectetur adipisicing elit. Eos, aspernatur quam.
  Libero eius rerum incidunt! Voluptates, quod fugiat repellendus molestias
  quibusdam ullam ratione mollitia.
      </blockquote>
      <blockquote>
  Lorem ipsum dolor sit amet consectetur adipisicing elit. Eos, aspernatur quam.
  Libero eius rerum incidunt! Voluptates, quod fugiat repellendus molestias
  quibusdam ullam ratione mollitia. Voluptates, quod fugiat repellendus
  molestias quibusdam ullam ratione mollitia.
      </blockquote>
      <h4>{`Javascript`}</h4>
      <pre><code parentName="pre" {...{
          "className": "language-js"
        }}>{`// comments
const name = 'john';
const channel = 'coding addict';

function featuredProducts(data) {
  return data.filter(item => {
    return item.featured === true;
  });
}
featuredProducts();
`}</code></pre>
      <h4>{`JSX`}</h4>
      <pre><code parentName="pre" {...{
          "className": "language-jsx"
        }}>{`import React from 'react';

const Counter = () => {
  const [count, setCount] = React.useState(0);
  return (
    <section className="counter">
      <h4>show some love to MDX</h4>
      <h4>likes {count}</h4>
      <button className="btn btn-danger" onClick={() => setCount(count + 1)}>
        i like mdx
      </button>
    </section>
  );
};
export default Counter;
`}</code></pre>
      <h4>{`HTML`}</h4>
      <pre><code parentName="pre" {...{
          "className": "language-html"
        }}>{`<h1>hello world</h1>
<p class="random">random text</p>
<section class="contact">
  <div class="title">
    <h1>contact us</h1>
  </div>
</section>
`}</code></pre>
      <h4>{`CSS`}</h4>
      <pre><code parentName="pre" {...{
          "className": "language-css"
        }}>{`max-width: 500px;
border-radius: var(--radius);
padding: 1rem 1.5rem;
background: var(--clr-grey-10);
text-align: center;
`}</code></pre>
      <Link to="/posts" className="btn center-btn" mdxType="Link">
  all posts
      </Link>
    </section>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      